import { useSwrMutationApi } from 'src/hooks/useSwrApi/useSwrMutationApi';

interface UseSwrEmployerBrandingActivateProps {
  locale: string;
  onSuccess?: () => void | Promise<void>;
  onError?: (err: unknown) => void;
}

export const useSwrEmployerBrandingActivate = (props: UseSwrEmployerBrandingActivateProps) => {
  const { locale, onSuccess, onError } = props;

  const {
    data, error, isMutating, reset, trigger,
  } = useSwrMutationApi<undefined, undefined>({
    url: '/v1/employer-branding/activate',
    locale,
    fetcherConfig: {
      method: 'POST',
      stringifyPayload: true,
    },
    apiOptions: {
      onSuccess: () => { if (onSuccess) { void onSuccess(); } },
      onError: (err) => { if (onError) onError(err); },
    },
    toastsOptions: {
      showErrorToast: true,
      showSuccessToast: true,
      successToastText: 'Activated successfully',
    },
  });

  return {
    data,
    error,
    isMutating,
    reset,
    trigger,
  };
};
